import { useTranslation } from 'react-i18next';

import { Image } from '@bonusly/design-system';

import banner from '../../../../assets/images/award-banner.svg';

export const ModalBanner = () => {
	const { t } = useTranslation('recognition');

	return <Image alt={t('awards.give_modal.select_award_banner') ?? ''} src={banner} />;
};
